(() => {
  'use strict';

  if (window.mechstockCardRowAlignmentLoaded) return;
  window.mechstockCardRowAlignmentLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const heightProperty = '--mechstock-row-height';
  const adjustedElements = new Set();

  let pendingFrame = null;

  function clearPreviousHeights() {
    adjustedElements.forEach((element) => {
      element.style.removeProperty(heightProperty);
    });

    adjustedElements.clear();
  }

  function matchHeights(elements) {
    const visibleElements = elements.filter(
      (element) => element && element.getClientRects().length > 0
    );

    if (visibleElements.length < 2) return;

    const tallestHeight = Math.max(
      ...visibleElements.map(
        (element) => element.getBoundingClientRect().height
      )
    );

    if (tallestHeight <= 0) return;

    // Round upwards to avoid fractional-pixel clipping.
    const height = `${Math.ceil(tallestHeight)}px`;

    visibleElements.forEach((element) => {
      element.style.setProperty(heightProperty, height);
      adjustedElements.add(element);
    });
  }

  function alignCards() {
    pendingFrame = null;

    // Restore natural heights before every measurement.
    clearPreviousHeights();

    if (!mobileQuery.matches) return;

    const groups = new Map();

    document
      .querySelectorAll('.product-card-wrapper')
      .forEach((wrapper) => {
        if (wrapper.getClientRects().length === 0) return;

        const rect = wrapper.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        // Keep separate grids separate, even if they share a vertical position.
        const gridItem = wrapper.closest('.grid__item');
        const container = gridItem
          ? gridItem.parentElement
          : wrapper.parentElement;

        if (!container) return;

        const title = wrapper.querySelector(
          '.card > .card__content .card__information > .card__heading'
        );

        const detail = wrapper.querySelector(
          '.mechstock-extra-detail'
        );

        if (!title && !detail) return;

        if (!groups.has(container)) {
          groups.set(container, []);
        }

        groups.get(container).push({
          top: rect.top,
          left: rect.left,
          title,
          detail
        });
      });

    groups.forEach((cards) => {
      cards.sort((a, b) => a.top - b.top || a.left - b.left);

      const rows = [];

      cards.forEach((card) => {
        // Small tolerance allows for fractional layout coordinates.
        let row = rows.find(
          (existingRow) => Math.abs(existingRow.top - card.top) <= 3
        );

        if (!row) {
          row = { top: card.top, cards: [] };
          rows.push(row);
        }

        row.cards.push(card);
      });

      rows.forEach((row) => {
        matchHeights(row.cards.map((card) => card.title));
        matchHeights(row.cards.map((card) => card.detail));
      });
    });
  }

  function scheduleAlignment() {
    if (pendingFrame !== null) return;
    pendingFrame = window.requestAnimationFrame(alignCards);
  }

  function start() {
    scheduleAlignment();

    window.addEventListener('resize', scheduleAlignment, {
      passive: true
    });

    window.addEventListener('load', scheduleAlignment);

    document.addEventListener(
      'load',
      (event) => {
        if (
          event.target instanceof HTMLImageElement &&
          event.target.closest('.product-card-wrapper')
        ) {
          scheduleAlignment();
        }
      },
      true
    );

    document.addEventListener(
      'shopify:section:load',
      scheduleAlignment
    );

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', scheduleAlignment);
    } else {
      mobileQuery.addListener(scheduleAlignment);
    }

    if (document.fonts) {
      document.fonts.ready.then(scheduleAlignment);

      if (document.fonts.addEventListener) {
        document.fonts.addEventListener(
          'loadingdone',
          scheduleAlignment
        );
      }
    }

    // Recalculate when filtering, pagination, or app content
    // replaces cards or changes their text.
    const observer = new MutationObserver((mutations) => {
      const affectsCards = mutations.some((mutation) => {
        const target =
          mutation.target instanceof Element
            ? mutation.target
            : mutation.target.parentElement;

        if (target && target.closest('.product-card-wrapper')) {
          return true;
        }

        if (mutation.type === 'childList') {
          const changedNodes = [
            ...mutation.addedNodes,
            ...mutation.removedNodes
          ];

          return changedNodes.some(
            (node) =>
              node instanceof Element &&
              (
                node.matches('.product-card-wrapper') ||
                node.querySelector('.product-card-wrapper')
              )
          );
        }

        return false;
      });

      if (affectsCards) scheduleAlignment();
    });

    // Attribute changes are deliberately excluded, so our own
    // height adjustments cannot trigger an observer loop.
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
